import {Singleton} from "@denishussar/html5-game-engine";
import {SwitchModel, SYMBOLS} from "./SwitchModel";
import * as _ from "lodash"

@Singleton
export class ElectricityModel {

     public switches: SwitchModel[] = new Array<SwitchModel>();
     public code: string[] = _.shuffle(SYMBOLS);

    constructor() {
        for(let i = 0; i < SYMBOLS.length; i++) {
            this.switches[i] = new SwitchModel(SYMBOLS[i], i);
        }
    }

}
